import { ImageEditorModalWithCropComponent } from "@circle-react-shared/ImageEditorModalWithCrop/ImageEditorModalWithCropComponent";
import { ASPECT_RATIO } from "@circle-react/components/constants";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { useDeferredCompassModalClose } from "@circle-react/components/QuickPostV3/hooks/useDeferredCompassModalClose";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";
import { useCallback, useState } from "react";

import { t } from "@/i18n-js/instance";

interface CoverImagePickerModalProps {
  onAttach: (signedId: string) => void;
}

const CoverImagePickerModalComponent = ({
  onAttach,
}: CoverImagePickerModalProps) => {
  const { isOpen, hide: closeModal } = useDeferredCompassModalClose();
  const [hasFile, setHasFile] = useState(false);
  const isMobile = useIsMobile();

  const handleAttach = useCallback(
    (_imageUrl: string, signedId: string) => {
      onAttach(signedId);
    },
    [onAttach],
  );

  return (
    <ImageEditorModalWithCropComponent
      showModal={isOpen}
      closeModal={closeModal}
      attachImage={handleAttach}
      uploadProgress={() => undefined}
      aspectRatio={ASPECT_RATIO.DEFAULT}
      hasFile={hasFile}
      inputFieldName="cover_image"
      isCropEnabled
      setHasFile={setHasFile}
      size={isMobile ? "full-screen" : "lg"}
      title={t("quick_post_v2.choose_cover_image")}
    />
  );
};

const CoverImagePickerModal = ModalManager.create(
  (props: CoverImagePickerModalProps) => (
    <CoverImagePickerModalComponent {...props} />
  ),
);

export const useCoverImagePickerModal = () => useModal(CoverImagePickerModal);
